var render = function render(_c,_vm){return _c('i',{class:[
    {
      [_vm.$style.recording]: _vm.props.recording,
      [_vm.$style.muted]: _vm.props.muted
    },
    _vm.$style[_vm.props.color],
    _vm.$style.dot,
    _vm.data.class,
    _vm.data.staticClass
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }